var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Sidebar'),_c('div',{class:_vm.expanded ? 'squish' : '',attrs:{"id":"main-content"}},[_c('Nav'),_c('ProductTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }